import styled from "styled-components";

export const StyledDatePicker = styled.div`
    width: ${props => props.small ? "102px" : "100%"};
    margin-bottom: ${props => props.small ? "0" : "20px"};
    .react-datepicker-wrapper, .react-datepicker__input-container {
        width: 100%;
    }
    ${({ customStyle }) => customStyle && customStyle};
`;
export const StyledIconWrap = styled.div`
    padding: 0 15px;
    border-left: 1px solid ${({ theme }) => theme.colors.mediumGrey};
    display: ${props => props.woIcon? "none" : "block"}
`;
